<div class="o-grid">
	<div class="o-grid__cell">
		<div class="c-card c-panels">
			<div class="c-panel c-content u-hidden@md-and-up" *ngIf="vm.isDoctor">
				<div class="c-content c-content--slim u-no-ph">
					<item-booking-status-switch></item-booking-status-switch>
				</div>
			</div>
			<a class="c-panel c-panel--link" [routerLink]="[tab.href]" [attr.data-testid]="'booking-tab-' + tab.id" *ngFor="let tab of vm.tabs">{{ tab.label }}<span class="c-badge c-badge--s2 c-badge--inline" *ngIf="tab.status === 'PAYED' && tab.unconfirmedBookingsCount">{{ tab.unconfirmedBookingsCount }}</span> <span class="c-badge c-badge--s2 c-badge--inline" *ngIf="tab.id === 'request' && tab.unansweredRequestsCount > 0">{{ tab.unansweredRequestsCount }}</span></a>
			<a class="c-panel c-panel--link u-hidden@md-and-up" [routerLink]="['/bookings/instant']" *ngIf="vm.isInstantBookingAllowed">{{ 'Booking.Instant.Title' | translate }} <span class="c-badge c-badge--s2 c-badge--inline" *ngIf="vm.instantBookingsCount">{{ vm.instantBookingsCount }}</span></a>
		</div>
	</div>
</div>
